import { render, staticRenderFns } from "./create-course-template.view.vue?vue&type=template&id=2207f18c&"
import script from "./create-course-template.view.ts?vue&type=script&lang=ts&"
export * from "./create-course-template.view.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports